
<div class="not-found-container">
  <div class="center">
    <h1 class="p-mb-3" >{{ 'jumpin_error_headline' | translate }}</h1>
    <p class="p-mb-3" [translate]="'jumpin_error_explanation'"></p>
    <ig-button *ngIf="backAccount" (onClick)="goBack()" [label]="'jumpin_to_last_account' | translate"></ig-button>
  </div>

</div>
